import React from "react";

export const Portal = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div
      id="actionMenuPortal"
      className="ActionWrapper"
      style={{
        overflow: "hidden",
      }}
    >
      {children}
    </div>
  );
};
